export default function MandiRate() {
  return (
    <>
      <div className="h-12 bg-yellow-300 font-all font-bold">
        mandi rate will display here from api the ui will be adjust accordinlgy
      </div>
    </>
  );
}
